import NiTheme from './theme'
import NiButton from './button'
import NiLine from './line'
import NiInput from './input'
import NiTree from './tree'
import NiNoData from './no-data'
import NiDialog from './dialog'
import NiTable from './table'
import NiTableColumn from './table/col'
import NiIcon from './icon'
import NiTabs from './tabs'
import NiTabPane from './tabs/tab-pane'
import NiDivider from './divider'
import NiDrawer from './drawer'


const version = '__VERSION__';
const components = {
  NiTheme,
  NiButton,
  NiInput,
  NiTree,
  NiNoData,
  NiDialog,
  NiTable,
  NiTableColumn,
  NiIcon,
  NiTabs,
  NiTabPane,
  NiDivider,
  NiDrawer,

}

// function install (Vue) {
//   Object.keys(components).forEach((key) => {
//     Vue.use(components[key]);
//   });
// }


// if (typeof window !== 'undefined' && window.Vue) install(window.Vue);

export {
  NiTheme,
  NiButton,
  NiLine,
  NiInput,
  NiTree,
  NiNoData,
  NiDialog,
  NiTable,
  NiTableColumn,
  NiIcon,
  NiTabs,
  NiTabPane,
  NiDivider,
  NiDrawer,

}
export default {
  ...components
}





// WEBPACK FOOTER //
// ./src/ni-ui/index.js